// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"ece337d2","768":"6d3ca06c"}[chunkId] + ".chunk.js";
};